// Dependencies
import styled from 'styled-components';

const QaModalsStyles = styled.section`
  padding: var(--spacing-standard-mobile) 0 0;
  text-align: center;

  .heading {
    margin: 0 0 0.5rem;
  }

  .subheading {
    font-weight: var(--font-weight-light);
    color: var(--color-bark);
  }

  .qa-modals {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-column-gap: 1.5rem;
    grid-row-gap: 1.5rem;
    grid-auto-rows: auto;
    margin: 4rem 0 0;
    text-align: left;

    .qa-modal {
      display: inline-block;
      padding: 2rem;
      border: 0.063rem solid var(--color-swiss-coffee);
      background: var(--color-white);

      .title {
        margin: 0 0 0.8rem;
        font-weight: var(--font-weight-medium);
      }

      .btn {
        margin: 1.5rem 0 0;
        color: var(--color-bark);
      }
    }
  }

  @media (min-width: 768px) {
    padding: var(--spacing-standard-desktop) 0;

    .qa-modals {
      grid-template-columns: repeat(2, 1fr);
      margin: 6.5rem 0 0;
    }
  }

  @media (min-width: 1200px) {
    .qa-modals {
      grid-template-columns: repeat(3, 1fr);
    }
  }
`;

export default QaModalsStyles;
